import { useNavigate } from 'react-router-dom'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { SOMYA_ADDICTION_EVENT_URL } from '../../BehavioralAddictionPlan'
import {
  BAPMainCardActionButtonMain,
  BAPMainCardActionButtonSecondary,
  BAPMainCardActionButtonsContainer,
  BAPMainCardContainer,
  BAPMainCardDetailsContainer,
  BAPMainCardImage,
  BAPMainCardImageContainer,
  ChangeInner,
  ChangeOuter,
  Pre,
  TextCarousel,
  TextCarouselElement,
  TextCarouselFrame,
} from './styledComponents'

export default function BehavioralAnxietyPlansMainCard({ buttonsOnClick, goToOnboarding }) {
  const navigate = useNavigate()

  function goToSomyaPlan() {
    buttonsOnClick ? buttonsOnClick() : navigate(SOMYA_ADDICTION_EVENT_URL)
  }
  function goToSomyaPlanWithParam() {
    goToOnboarding()
  }

  function openAddictionPage() {
    // buttonsOnClick ? buttonsOnClick() : navigate('/assessment/gaming-addiction')
    buttonsOnClick ? buttonsOnClick() : navigate('assessment-selection')
  }

  return (
    <BAPMainCardContainer>
      <BAPMainCardDetailsContainer>
        <div className="layout-container">
          <div className="d-flex flex-column gap-3 w-100">
            {/* <span className="card-details-text">Addicted to GAMING?</span> */}
            <span className="card-details-text">
              <BehaviouralAnxietyPlansMainHeadingComponent />
            </span>
            <span className="card-details-text-secondary">
              Discover innovative approaches tailored to your unique journey, redefining mental health care.
            </span>
          </div>
          <BAPMainCardActionButtonsContainer>
            <BAPMainCardActionButtonMain onClick={goToSomyaPlan}>
              CHAT WITH AN EXPERT
            </BAPMainCardActionButtonMain>
            <BAPMainCardActionButtonSecondary onClick={openAddictionPage}>
              TAKE THE FREE ASSESSMENT
            </BAPMainCardActionButtonSecondary>
            <BAPMainCardActionButtonSecondary onClick={goToSomyaPlanWithParam}>
              START YOUR PLAN
            </BAPMainCardActionButtonSecondary>
            {/* <BAPMainCardActionButtonMain>Action Button 2</BAPMainCardActionButtonMain>
          <BAPMainCardActionButtonMain>Action Button 3</BAPMainCardActionButtonMain> */}
          </BAPMainCardActionButtonsContainer>
        </div>
      </BAPMainCardDetailsContainer>
      <BAPMainCardImageContainer>
        {/* <BAPMainCardImage src={unsplashImages?.results?.[3]?.urls?.full} /> */}
        <BAPMainCardImage src={getImageLink('MEDIA-66c559af9258435aa5dea4b15d6adc92')} alt='BAPBackground' />
        {/* <Carousel
          style={{ zIndex: 0 }}
          fade
          controls={false}
          interval={2700}
          pause={false}
          keyboard={false}
        >
          <Carousel.Item>
            <BAPMainCardImage src={unsplashImages?.results?.[1]?.urls?.full} />
          </Carousel.Item>
          <Carousel.Item>
            <BAPMainCardImage src={unsplashImages?.results?.[2]?.urls?.full} />
          </Carousel.Item>
          <Carousel.Item>
          </Carousel.Item>
        </Carousel> */}
      </BAPMainCardImageContainer>
    </BAPMainCardContainer>
  )
}

const BehaviouralAnxietyPlansMainHeadingComponent = () => {
  const arr = [
    'GAMING',
    'INTERNET',
    'SMOKING',
    'PORN',
    'SOCIAL MEDIA',
    'CAFFEINE',
    'FOOD',
    'GAMING',
  ]
  return (
    <TextCarouselFrame>
      <TextCarousel>
        <Pre>Addicted to </Pre>
        <ChangeOuter>
          <ChangeInner>
            {arr?.map((item, index) => {
              return <TextCarouselElement key={index}>{item}?</TextCarouselElement>
            })}
          </ChangeInner>
        </ChangeOuter>
      </TextCarousel>
    </TextCarouselFrame>
  )
}
